export const ONBOARDING_STEPS = {
  TEMPLATE: 1,
  DATA: 2,
  QUESTIONS: 3,
  REVEAL: 4,
} as const;

export type OnboardingStep = typeof ONBOARDING_STEPS[keyof typeof ONBOARDING_STEPS];

export interface OnboardingTemplate {
  key: "quote" | "contract" | "proposal";
  label: string;
  templateSlug: string;
  sampleTemplateSlug: string;
  samplePdf: string;
  graphic: string;
  taggedGraphic: string;
}

export const ONBOARDING_TEMPLATES: OnboardingTemplate[] = [
  {
    key: "quote",
    label: "Quote",
    templateSlug: "quotes",
    sampleTemplateSlug: "quotes",
    samplePdf: "/assets/onboarding/onboarding-pdf-quote.pdf",
    graphic: "/assets/onboarding/quote-hubspot-template.svg",
    taggedGraphic: "/assets/onboarding/quote-hubspot-template-tagged.svg",
  },
  {
    key: "contract",
    label: "Contract",
    templateSlug: "contracts",
    sampleTemplateSlug: "contracts",
    samplePdf: "/assets/onboarding/onboarding-pdf-contract.pdf",
    graphic: "/assets/onboarding/contract-nda.svg",
    taggedGraphic: "/assets/onboarding/contract-nda-tagged.svg",
  },
  {
    key: "proposal",
    label: "Proposal",
    templateSlug: "proposals",
    sampleTemplateSlug: "proposals",
    samplePdf: "/assets/onboarding/onboarding-pdf-proposal.pdf",
    graphic: "/assets/onboarding/simple-proposal-template.svg",
    taggedGraphic: "/assets/onboarding/simple-proposal-template-tagged.svg",
  },
];

export type OnboardingDataSelection =
  | { kind: "hubspot_deal"; dealId: string; dealName: string }
  | { kind: "sample" };

export const ONBOARDING_SAMPLE_COMPANY = "Acme Corp";
